/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 6/18/19
 * Time: 10:05 AM
 */

import React,{Component} from 'react';
import {Input,Dropdown} from "semantic-ui-react";
import '../../Input/LabelButtonsInput/LabelButtonsInput.css'


const App = (props) => (

  <Input
    className={props.className}
    autoFocus={props.autoFocus}
    id={props.id}
    onClick={props.inputClick}
    input={<input ref={props.ref} style={{display:'none'}}/>}
    style={{width:'100%',marginBottom:'12px',height:'40px'}}
    label={!props.noneLable ? <label style={{width:props.lblWidth?props.lblWidth : '110px',fontSize:props.lblFontSize}} className="ui label">{props.tagText}
      {
        props.required ?
          <span className={"required-field-input"}>*</span>
          : null
      }
    </label>:null}
    labelPosition='left'
    placeholder={props.placeholder}
    action={<Dropdown disabled={props.loading || props.disable} clearable={props.clearable} multiple={props.multiple} selection onClick={props.inputClick} value={props.value} onSearchChange={props.onSearchChange} defaultValue={props.defaultValue} onChange={props.onChange} search style={{width:'100%'}} button basic floating options={props.options} placeholder={props.placeholder} loading={props.loading} selectOnBlur={false}/>}

  />
);

export default App
